/**
 * 本地存储工具
 * 用于统一管理localStorage的key，避免与其他平台冲突
 */

/**
 * 管理后台专用的存储key
 * 与分利客平台区分开，避免token冲突
 */
export const STORAGE_KEYS = {
    // 管理后台token（区分于分利客平台的'usetoken'）
    ADMIN_TOKEN: 'admin_backend_token',
    
    // 用户信息
    USER_INFO: 'admin_userinfo',
} as const

/**
 * 获取token
 */
export const getToken = (): string | null => {
    return localStorage.getItem(STORAGE_KEYS.ADMIN_TOKEN)
}

/**
 * 设置token
 */
export const setToken = (token: string): void => {
    localStorage.setItem(STORAGE_KEYS.ADMIN_TOKEN, token)
}

/**
 * 移除token
 */
export const removeToken = (): void => {
    localStorage.removeItem(STORAGE_KEYS.ADMIN_TOKEN)
}

/**
 * 获取用户信息
 */
export const getUserInfo = (): any => {
    const userInfo = localStorage.getItem(STORAGE_KEYS.USER_INFO)
    return userInfo ? JSON.parse(userInfo) : null
}

/**
 * 设置用户信息
 */
export const setUserInfo = (userInfo: any): void => {
    localStorage.setItem(STORAGE_KEYS.USER_INFO, JSON.stringify(userInfo))
}

/**
 * 移除用户信息
 */
export const removeUserInfo = (): void => {
    localStorage.removeItem(STORAGE_KEYS.USER_INFO)
}

/**
 * 清除所有管理后台相关数据
 */
export const clearAdminStorage = (): void => {
    removeToken()
    removeUserInfo()
}


